import AOS from '@netc/aos';
import whenDomReady from 'when-dom-ready';
function initialise() {
    new AOS();
}
whenDomReady().then(initialise);
